<div class="card makery-card makery-card-visible
{{(reservation.reservationStatus == 'SUCCEEDED')?'makery-card-success':'makery-card-accepted'}}">
  <div class="card-header ">
    <div class="row">
      <div class="col-md-7 col-sm-10 col">
        <p class="card-title">{{reservation.reservationTime + ' - ' + reservation.personCount + ' fő'}}
          <span *ngIf="reservation.survey.length">(</span>
          <span *ngFor="let survey of reservation.survey">{{survey | translate}}</span>
          <span  *ngIf="reservation.survey.length">)</span></p>
      </div>
      <div class="col-md-5 col-sm-2 makery-control col">
        <button class="btn btn-simple btn-tooltip mr-2 btn-hide pr-0 pl-3"
                data-animation="true"
                data-container="body"
                placement="bottom"
                tooltip="{{'reservation.closeEdit' | translate}}"
                (click)="setEdit()">
          <i class="fas fa-pencil-alt"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-sm-12 col-md-9 col" >
        <app-reservation-card-userdata [reservation]="reservation" ></app-reservation-card-userdata>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col-sm-12 col">
        <div class="row" *ngFor="let guest of reservation.guests; let i = index">
          <div class="col-12 makery-food-section">
            <h3>{{guest.nickname}}</h3>

            <ul *ngIf="guest.preorderedDiys.length > 0 && !isLoading">
              <li *ngFor="let diyElement of guest.preorderedDiys; let j = index" class="{{ diyElement.status}}">
                <div class="row">
                  <div class="col-md-2">
                    <img class="lazy card-img" src="{{diyElement.diy.traySrc}}"
                    />
                  </div>

                  <div class="col-md-5">
                    {{diyElement.diy.localizations[translate.currentLang].name}}
                  </div>
                  <div class="col-md-5 col-sm-2 makery-control" *ngIf="diyElement.status==null || diyElement.status=='SELECTED'">
                    <button class="btn btn-simple btn-tooltip mr-2 btn-hide"
                            data-animation="true"
                            data-container="body"
                            placement="bottom"
                            tooltip="{{'guest.deleteDiy' | translate}}"
                            (click)="deleteDiyFromGuest(j, i)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
            <div class="row alert alert-warning" *ngIf="guest.preorderedDiys.length < 1">
              <div class="col-sm-12 col">
                <i class="fa-solid fa-triangle-exclamation"></i><span class="ml-1">{{'guest.noFoodSelected' | translate}}</span>
              </div>
            </div>


            <div class="row" *ngIf="selecTableDiys">
              <div class="col-md-12">
                <label>{{'guest.addNewDiy' | translate}}</label>
                <angular2-multiselect
                  (onSelect)="addNewDiyToGuest($event, i)"
                  [data]="selecTableDiys"
                  [(ngModel)]="selectedDiys"
                  [settings]="{
                      singleSelection: true,
                      enableSearchFilter: true,
                      text: translate.instant('guest.selectNewDiy'),
                      classes: 'btn-danger',
                      lazyLoading: true,
                      maxHeight: 400
                    }"
                >
                </angular2-multiselect>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

